import { Endpoint } from "shared/utils/endpoints";
import { HTTP_CLIENT } from "shared/utils/interceptor";

const ContactUsService = (payload: any) => {
  return HTTP_CLIENT.post(Endpoint.general.contactus, payload);
};

const GetDashboardStatsService = () => {
  return HTTP_CLIENT.get(Endpoint.general.stats);
};

const GetUsersListService = () => {
  return HTTP_CLIENT.get(Endpoint.general.listUsers);
};

const GetOptionsListService = () => {
  return HTTP_CLIENT.get(Endpoint.general.listOptions);
};

export {
  ContactUsService,
  GetDashboardStatsService,
  GetUsersListService,
  GetOptionsListService,
};
